/**
 * SASHA Player - Entry Point
 * 
 * Player audio modulare con Web Components
 * @author Mondadori Digital
 */

// Import versione da package.json
import pkg from '../package.json' assert { type: 'json' };

// Core
export { SashaPlayer } from './core/SashaPlayer.js';
export { StateManager } from './core/StateManager.js';
export { AudioManager } from './core/AudioManager.js';
export { WaveformRenderer } from './core/WaveformRenderer.js';

// Managers
export { ConfigManager } from './managers/ConfigManager.js';
export { ThemeManager } from './managers/ThemeManager.js';
export { TemplateEngine } from './managers/TemplateEngine.js';
export { AdManager } from './managers/AdManager.js';

// UI
export { ControlsManager } from './ui/ControlsManager.js';
export { DOMUpdater } from './ui/DOMUpdater.js';

// Utils
export { formatTime, generateId, escapeHtml } from './utils/format.js';
export { dispatchCustomEvent, waitForEvent, isEventReady } from './utils/events.js';
export { $, $$, attachListener, setDataAttr } from './utils/dom.js';
export { isValidUrl, validateConfig } from './utils/validator.js';

// Constants
export { DEFAULT_CONFIG, DEFAULT_ADVANCED, PLAYER_STATES, EVENTS } from './constants/defaults.js';
export { AD_TYPES, AD_SOURCES, AD_STATES, AD_EVENTS, POSITION_TYPES, DEFAULT_FREQUENCY_CAP } from './constants/adTypes.js';
export { SpreakerParser } from './parsers/SpreakerParser.js';
export { SpreakerProvider } from './providers/SpreakerProvider.js';

// Parsers
export { VASTParser } from './parsers/VASTParser.js';

// Import principale
import { SashaPlayer } from './core/SashaPlayer.js';

// Auto-registrazione del Web Component
if (typeof window !== 'undefined' && !customElements.get('sasha-player')) {
  customElements.define('sasha-player', SashaPlayer);
  console.log('🎵 Sasha Player registered');
}

// Export default per uso come modulo
export default SashaPlayer;

// Versione dinamica da package.json
export const version = pkg.version;

